import config from '@/config'

const { cdn } = config

export default {
  namespaced: true,
  state: () => ({
    mixedHouseholdTrash: {
      canBeSelected: true,
      label: 'Mixed Household<br>Trash',
      value: 'mixedHouseholdTrash',
      icon: `${cdn}icons-household-trash.svg`
    },
    constructionDebris: {
      canBeSelected: true,
      label: 'Construction<br>Debris',
      value: 'constructionDebris',
      icon: `${cdn}icons-construction-debris.svg`
    },
    heavy: {
      canBeSelected: true,
      label: 'Heavy Stuff<br>(Brick, Dirt, etc)',
      value: 'heavy',
      icon: `${cdn}icons-heavy-stuff.svg`
    },
    yardOrOrganicMaterial: {
      canBeSelected: true,
      label: 'Yard or Organic<br>Material',
      value: 'yardOrOrganicMaterial',
      icon: `${cdn}icons-yard-organic-material.svg`
    }
  }),
  mutations: {
    // Enforce debris selection and combination rules.
    debrisMatrix (state, { debris }) {
      state.mixedHouseholdTrash.canBeSelected = true
      state.constructionDebris.canBeSelected = true
      state.heavy.canBeSelected = true
      state.yardOrOrganicMaterial.canBeSelected = true

      // Keep every debris type available when none is selected.
      if (!debris.length) return

      if (debris.length === 2) {
        if (!debris.includes(state.mixedHouseholdTrash.value)) {
          state.mixedHouseholdTrash.canBeSelected = false
        }
        if (!debris.includes(state.constructionDebris.value)) {
          state.constructionDebris.canBeSelected = false
        }
        if (!debris.includes(state.heavy.value)) {
          state.heavy.canBeSelected = false
        }
        if (!debris.includes(state.yardOrOrganicMaterial.value)) {
          state.yardOrOrganicMaterial.canBeSelected = false
        }
      }

      const nonHeavy = [
        state.mixedHouseholdTrash.value,
        state.constructionDebris.value,
        state.yardOrOrganicMaterial.value
      ]
      const hasHeavy = debris.includes(state.heavy.value)
      const hasNonHeavy = debris.some(d => nonHeavy.includes(d))

      if (hasNonHeavy) {
        state.heavy.canBeSelected = false
      }

      if (hasHeavy) {
        state.mixedHouseholdTrash.canBeSelected = false
        state.constructionDebris.canBeSelected = false
        state.yardOrOrganicMaterial.canBeSelected = false
      }
    }
  }
}
